export default __webpack_public_path__ + "static/media/F_Farol.f48a99c3.mp3";